import styled from '@emotion/styled'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import GrooverText from './GrooverText'
import { buildAdminWebUrl } from '../libs/AdminWebUrlHelper'
import { buildReceptionAppDebugCheckinPath } from '../../../pure-js/libs/receptionAppDebugUrl'
import { getGrooverText } from '../libs/GrooverTextRepository'
import { Language } from '../../../pure-js/types/Antiloop'

type Props = {
  clientId: string
  checkinQr: string
  language?: Language
}

const LABEL_COLOR = '#5b21b6'

const RegisterOpenInCheckinAppButton = ({ clientId, checkinQr, language }: Props) => {
  const href = buildAdminWebUrl(buildReceptionAppDebugCheckinPath(clientId, checkinQr))
  const label = getGrooverText('registerPage.openInCheckinApp', language)

  return (
    <LinkButton href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
      <OpenInNewIcon sx={{ fontSize: 16, color: `${LABEL_COLOR} !important` }} aria-hidden />
      <GrooverText
        textKey="registerPage.openInCheckinApp"
        language={language}
        style={{ color: LABEL_COLOR, fontWeight: 800 }}
      />
    </LinkButton>
  )
}

const LinkButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 4px;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid rgba(124, 58, 237, 0.35);
  background: rgba(124, 58, 237, 0.08);
  color: ${LABEL_COLOR};
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
  align-self: center;

  && .MuiSvgIcon-root {
    color: ${LABEL_COLOR} !important;
    fill: currentColor !important;
  }

  &:hover {
    background: rgba(124, 58, 237, 0.14);
    color: #4c1d95;

    && .MuiSvgIcon-root {
      color: #4c1d95 !important;
    }
  }
`

export default RegisterOpenInCheckinAppButton
